export default __webpack_public_path__ + "images/Dia-Regular.font.fdc17cf2dbdc2ce8b7ebcf2828d78959.svg";